import React from 'react';
import { Link } from '@nerdwallet/currency';

export default {
  tiles: [
    {
      id: 0,
      title: 'Supporting the work of MDIs through grant giving',
      copy: (
        <React.Fragment>
          In 2021, we established the Bay Area Impact Fund, donating directly to
          enable day-to-day operations with three local minority depository
          institutions (MDIs) in the Bay Area:{' '}
          <Link href="https://www.self-helpfcu.org/">
            The Self-Help Federal Credit Union
          </Link>
          ,{' '}
          <Link href="https://necfcu.weebly.com/">
            Northeast Community Federal Credit Union
          </Link>
          , and{' '}
          <Link href="https://www.coopfcu.org/">
            Cooperative Center Federal Credit Union
          </Link>
          . <br /> <br />
          This year, we’re extending our impact nationally by donating directly
          to the{' '}
          <Link href="https://www.inclusiv.org/investing/racial-equity-funds/">
            Racial Equity Grant Fund{' '}
          </Link>
          to support up to 10 new MDI CDCUs and cooperativas. These sub grants
          will be used for operations, technology, outreach and ongoing recovery
          efforts in communities of color across the US and support these MDIs
          through the CDFI certification and CDFI grant writing processes to
          expand financial inclusion in the low-income communities of color they
          serve.
        </React.Fragment>
      ),
    },
    {
      id: 1,
      title: 'Tapping into the power of our Nerds',
      copy: "We're using our entire team's knowledge and expertise to support our credit union partners by offering our Marketing, Technical, and Financial support pro bono.",
    },
  ],
};
